<a
  [routerLink]="[navigationUrl, raffle.slug]"
  class="raffle-card raffle-card__{{ version }}"
  *ngIf="raffle"
  [class.raffle-card__overlay]="!raffle.is_open"
>
  <div class="raffle-card__image">
    <img
      [src]="raffle.thumbnail?.big"
      [alt]="raffle.title"
      [title]="raffle.title"
      [class.raffle-card__image--overlay]="!raffle.is_open"
    />
    <ng-container *ngIf="timeVersion">
      <div
        *ngIf="timeVersion === relativeTime.Today"
        class="raffle-card__pill raffle-card__drawtime"
        [ngClass]="raffle.is_open ? timeVersion : ''"
      >
        {{ badgeLabel }} Today
        {{ badgeTime | unifyDate | tzDate: timeFormat | lowercase }}
        {{ badgeTime | ukTimezone }}
      </div>
      <div
        *ngIf="timeVersion === relativeTime.Tomorrow"
        class="raffle-card__pill raffle-card__drawtime"
        [ngClass]="raffle.is_open ? timeVersion : ''"
      >
        {{ badgeLabel }} Tomorrow
        {{ badgeTime | unifyDate | tzDate: timeFormat | lowercase }}
        {{ badgeTime | ukTimezone }}
      </div>
      <div
        *ngIf="timeVersion === relativeTime.ThisWeek"
        class="raffle-card__pill raffle-card__drawtime"
      >
        {{ badgeLabel }} on {{ badgeTime | unifyDate | tzDate: 'EEEE' }}
        {{ badgeTime | unifyDate | tzDate: timeFormat | lowercase }}
        {{ badgeTime | ukTimezone }}
      </div>
      <div
        *ngIf="timeVersion === relativeTime.Launched"
        class="raffle-card__pill raffle-card__drawtime"
      >
        Just launched
      </div>
    </ng-container>

    <div class="raffle-card__pill raffle-card__closed" *ngIf="!raffle.is_open">
      {{ closedText | uppercase }}
    </div>
  </div>

  <app-countdown
    *ngIf="projectCode === projectCodes.UKCC"
    [expiredAt]="raffle?.end_at"
  ></app-countdown>

  <div class="raffle-card__wrapper">
    <div class="raffle-card__logo" *ngIf="isInstantWin">
      <app-raffle-instant-logo
        [instantType]="raffle.instant_win_type"
      ></app-raffle-instant-logo>
    </div>

    <div class="raffle-card__title">
      {{ raffle.title }}
    </div>

    <div class="raffle-card__subtitle" *ngIf="raffle.subtitle">
      {{ raffle.subtitle }}
    </div>

    <div
      *ngIf="raffle.cash_alternative"
      class="raffle-card__subtitle"
      [class.raffle-card__subtitle--margin]="raffle.subtitle"
    >
      Cash Alternative:
      {{ raffle.cash_alternative | currency: 'GBP' : 'symbol' : '1.0' }}
    </div>

    <div class="raffle-card__spacer"></div>

    <div class="raffle-card__price">
      <span class="raffle-card__price--original" *ngIf="originalPrice">
        {{ originalPrice | currency: currency }}
      </span>
      {{ price | currency: currency }}
    </div>

    <div class="raffle-card__slider">
      <div class="raffle-card__slider--sold"> sold: {{ sliderValue }} % </div>

      <div class="raffle-card__slider--track">
        <span
          class="raffle-card__slider--track-fill"
          [ngStyle]="{ width: sliderValue + '%' }"
        ></span>
      </div>
    </div>
    <div class="raffle-card__enter">
      {{ raffle.is_open ? 'Enter now' : 'View' }}
      <svg-icon
        *ngIf="projectCode === projectCodes.UKCC"
        class="raffle-card__enter--arrow"
        name="arrow-filled"
      ></svg-icon>
    </div>
  </div>
</a>
